/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// hide 'Scroll to Top' button
window.onscroll = function () {
    const returnToTop = document.getElementById("returnToTop");

    if (!returnToTop) return;

    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("returnToTop").style.display = "block";
    } else {
        document.getElementById("returnToTop").style.display = "none";
    }
};

window.addEventListener(
    'beforeprint', () => document.body.classList.add('print-media-mode')
)
window.addEventListener(
    'afterprint', () => document.body.classList.remove('print-media-mode')
)

// chart stuff
window.globalThis = window;

var bc = window.Barchart || {};
bc.Engagement = {};
bc.Engagement.EngagementGateway = require('@barchart/engagement-client-js/lib/gateway/EngagementGateway');
bc.Engagement.JwtProvider = require('@barchart/engagement-client-js/lib/security/JwtProvider');
bc.Engagement.Transport = require('@barchart/engagement-client-js/lib/data/Transport');
bc.Engagement.RegistrationStatus = require('@barchart/engagement-client-js/lib/data/RegistrationStatus');

window.Barchart = bc;

// window.Barchart.Utilities = require('@barchart/marketdata-utilities-js');
// window.Barchart.Utilities.stringToDecimalFormatter = require('./BarchartUtilities').default;
// window.Barchart.Utilities.priceFormatter = require('./BarchartUtilities').priceFormatter;
// window.Barchart.Utilities.unitCodeToBaseCode = require('./BarchartUtilities').unitCodeToBaseCode; // convertUnitCodeToBaseCode

/*
INSTEAD OF window.Barchart.Utilities.priceFormatter('-', true).format(fiftyPercent, baseCode);
USE const profile = new Profile(symbol, symbol, '', baseCode, 1000, 1); return stringFormatter(fiftyPercent, baseCode, profile);
OR import formatPrice from '@barchart/marketdata-api-js/lib/utilities/format/price'; return formatPrice(fiftyPercent, baseCode, '-', true);
*/

window.Barchart.getBaseCode = () => {
    const json = JSON.parse(window.document.getElementById('barchart-www-inline-data').innerHTML);
    return Object.keys(json).map(symbol => json[symbol].instrument.unitCode)[0];
};

window.Barchart.getFieldFromInlineTemplate = (field) => {
    const json = JSON.parse(window.document.getElementById('barchart-www-inline-data').innerHTML);
    return Object.keys(json).map(symbol => json[symbol].instrument[field])[0];
}

// FOR NEW CHART
/*
        "@barchart/chart": "^2.212.2",
        "@barchart/chart-panel": "^2.0.84",
        "@barchart/es6-webcomponents": "^2.49.9",
*/
// import { ChartModel, ITooltipChangedData, getFeed, getTaxonomies } from "@barchart/chart";
// window.getFeed = getFeed;
// console.log(window.getFeed);
